import { render, staticRenderFns } from "./AddRelatedMeasureModal.vue?vue&type=template&id=dd82aaca&"
import script from "./AddRelatedMeasureModal.vue?vue&type=script&lang=js&"
export * from "./AddRelatedMeasureModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports